module.exports = __webpack_public_path__ + "static/media/horse-fields.1a7bd82e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/horse-fields.jpg
 ** module id = 693
 ** module chunks = 0
 **/